import jwtDecode, { JwtPayload } from 'jwt-decode';

interface JWTValidationResult {
  valid: boolean;
  expired: boolean;
}

export function isValidJWT(token: string): boolean {
  try {
    const jwtParts = token.split('.');
    if (jwtParts.length !== 3) {
      return false;
    }

    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) {
      return false;
    }

    const now = Math.round(new Date().getTime() / 1000);
    return decoded.exp > now;
  } catch (exception) {
    return false;
  }
}

export function validateJWT(token: string): JWTValidationResult {
  const result: JWTValidationResult = { valid: false, expired: false };
  try {
    const jwtParts = token.split('.');
    if (jwtParts.length !== 3) {
      result.valid = false;
      return result;
    } 

    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) {
      result.valid = false;
      return result;
    }

    const now = Math.round(new Date().getTime() / 1000);
    result.valid = true;
    result.expired = decoded.exp < now;
  } catch (exception) {
    result.valid = false;
  }
  return result;
}
